import React, { useState } from "react";
import { NavLink, useRouteMatch } from "react-router-dom";
import { Box, Drawer, List, ListItem as MUIListItem, ListItemIcon, makeStyles, } from "@material-ui/core";
import ChevronIcon from "../icons/Chevron";
import clsx from "clsx";
import CloseIcon from "../icons/Close";
import BurgerIcon from "../icons/BurgerIcon";
import FTLTypography from "./FTLTypography";
import FTLDivider from "./FTLDivider";
import FTLIconButton from "../buttons/FTLIconButton";
function NestedListItemLink({ label, onClick, to = "", needHighlight, }) {
    const classes = useStyles();
    const route = to instanceof Function
        ? "#"
        : typeof to === "string"
            ? to
            : (to === null || to === void 0 ? void 0 : to.pathname) || "#";
    const match = useRouteMatch(route);
    const renderLink = React.useMemo(() => React.forwardRef((itemProps, ref) => React.createElement(NavLink, Object.assign({ to: to, ref: ref }, itemProps))), [to]);
    return (React.createElement(MUIListItem, { button: true, component: renderLink, onClick: onClick },
        React.createElement(FTLTypography, { variant: "p1Medium", color: "primary", className: clsx(classes.listItemText, match && needHighlight && classes.listItemTextActive) }, label)));
}
function ListItem({ onClick, to = "", label = "", subItems, disabled = false, icon, needHighlight, }) {
    const classes = useStyles();
    const route = to instanceof Function
        ? "#"
        : typeof to === "string"
            ? to
            : to.pathname || "#";
    const match = useRouteMatch(route);
    const renderLink = React.useMemo(() => React.forwardRef((itemProps, ref) => React.createElement(NavLink, Object.assign({ to: to, ref: ref }, itemProps))), [to]);
    const [nestedListMenuOpen, setNestedListOpen] = useState(Boolean(match || false));
    return (React.createElement(React.Fragment, null,
        React.createElement(MUIListItem, { className: classes.listItem, button: true, component: to && !subItems ? renderLink : "li", onClick: !subItems
                ? onClick
                : () => {
                    setNestedListOpen(!nestedListMenuOpen);
                }, disabled: disabled },
            React.createElement(ListItemIcon, { color: "primary", className: clsx(classes.listItemIcon, match && needHighlight && classes.listItemIconActive) }, icon),
            React.createElement(FTLTypography, { variant: "p1Medium", color: disabled ? "tertiary" : "primary", className: clsx(classes.listItemText, match && needHighlight && classes.listItemTextActive) }, label),
            subItems && (React.createElement(ChevronIcon, { className: match ? classes.listItemTextActive : undefined, direction: nestedListMenuOpen ? "top" : "bottom" }))),
        subItems && (React.createElement(React.Fragment, null,
            React.createElement(List, { disablePadding: true, className: clsx(classes.nestedList, !nestedListMenuOpen && classes.nestedListHidden) }, subItems.map((item, index) => {
                if (item.type === "divider") {
                    return React.createElement(Box, { ml: 3, mr: 3 },
                        React.createElement(FTLDivider, { margin: 2 }));
                }
                else {
                    return (React.createElement(NestedListItemLink, { key: index, to: item.to, label: item.label, onClick: () => {
                            onClick && onClick();
                            item.onClick && item.onClick();
                        }, needHighlight: item.needHighlight }));
                }
            }))))));
}
export default React.forwardRef(({ items, open, onOpen, onClose }, ref) => {
    const classes = useStyles();
    return (React.createElement(React.Fragment, null,
        React.createElement(FTLIconButton, { onClick: () => {
                if (open)
                    onClose();
                else
                    onOpen();
            } }, !open ? (React.createElement(BurgerIcon, { sizeRatio: 1.2 })) : (React.createElement(CloseIcon, { sizeRatio: 1.8 }))),
        React.createElement(Drawer, { anchor: "bottom", open: open, onClose: onClose, disableEnforceFocus: true, ref: ref, elevation: 0, classes: {
                paper: classes.paper,
            } },
            React.createElement(List, { component: "nav" }, items.map((item) => {
                if (item.type === "divider") {
                    return React.createElement(Box, { ml: 3, mr: 3 },
                        React.createElement(FTLDivider, { margin: 2 }));
                }
                else {
                    return (React.createElement(React.Fragment, null,
                        React.createElement(ListItem, Object.assign({ key: item.label, subItems: item === null || item === void 0 ? void 0 : item.items, onClick: () => {
                                onClose();
                                item.onClick && item.onClick();
                            } }, item))));
                }
            })))));
});
const useStyles = makeStyles((theme) => ({
    listItem: {
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2),
    },
    listItemText: {
        width: "100%",
    },
    listItemTextActive: {
        color: theme.palette.link.primary,
    },
    listItemIconActive: {
        "& svg": {
            fill: theme.palette.link.primary,
        },
    },
    listItemIcon: {
        minWidth: "initial",
        color: theme.palette.text.primary,
        marginRight: "8px",
        "& svg": {
            width: 20,
            height: 20,
        },
    },
    nestedList: {
        display: "block",
    },
    nestedListHidden: {
        display: "none",
    },
    paper: {
        width: "100%",
        height: "calc(100% - 56px)",
        backgroundColor: theme.palette.background.paper,
        overflowX: "hidden",
    },
}));
//# sourceMappingURL=FTLMobileMenu.js.map